// extracted by mini-css-extract-plugin
export default {"services":"services_services__zK7k9","header":"services_header__GrEaG","grid":"services_grid__chkb1","card":"services_card__n0PVX","icon":"services_icon__g1+NJ"};